<template>
    <div class="vm-action-feed-filter" :class="[browser_size]">
        <template v-if="status == 1">
            <div class="item flex-box flex-a-center flex-bet fs16 black-8">
                <span>{{$t('c.ActionFeedFilter.text1')}}</span>
                <switches v-if="has_init" theme="custom" color="purple" v-model="is_sponsoring"></switches>
            </div>
            <!-- <div class="item flex-box flex-a-center flex-bet fs16 black-8">
                <span>只看公开与已解锁的动态</span>
                <switches v-if="has_init" theme="custom" color="purple" v-model="is_unlock"></switches>
            </div> -->
            <div class="line mt20 mb20"></div>
            <div class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text" @click="tab(2)">
                <span>{{$t('c.ActionFeedFilter.text2')}}</span>
                <i class="afd afd-arrow-right fs14 black-3"></i>
            </div>
        </template>
        <template v-if="status == 2">
            <template v-if="has_load && user_list.length > 0">
                <div v-for="(item, i) in user_list" :key="i" class="item flex-box flex-a-center flex-bet fs14 black-8">
                    <avatar class="wh24" :user="item"/>
                    <span class="black-3 fs14 gl-hover-text" @click="cancel_blacklist(item.user_id)">{{$t('c.ActionFeedFilter.text3')}}</span>
                </div>
            </template>
            <div v-if="has_load && user_list.length == 0" class="item flex-box flex-a-center flex-bet fs16 black-3">
                {{$t('c.ActionFeedFilter.text4')}}
            </div>
        </template>
    </div>
</template>

<script>
import { POST_UPDATE_USER_FEED_SETTING,GET_BLOCKED_CREATORS,GET_SESSION_USER} from "@/api/config";

import { mapState } from "vuex";
export default {
  name: "action-feed-filter",
  props: {
    album: {},
  },
  inject:['app_action_sheet'],
  data() {
    return {
        status:1,
        user_list:[],
        has_load:false,
        is_sponsoring:false,
        is_unlock:false,
        has_init:false,
    };
  },
  watch:{
      is_sponsoring(v){
          if(!this.has_init){
              return
          }
          this.submit({sponsoring:v ? 1 :0})
          this.session_user.user_feed_setting.sponsoring = v
      },
      is_unlock(v){
          if(!this.has_init){
              return
          }
          this.submit({unlock:v ? 1 :0})
          this.session_user.user_feed_setting.unlock = v
      },
  },
  computed: {
    ...mapState("app", ["browser_size",'session_user']),
  },
  beforeDestroy(){
  },
  mounted() {
    this.init()
  },
  methods: {
    async init(){
      let re = await this.$mixin_waitting_api(GET_SESSION_USER);
      if(re){
          this.is_sponsoring = this.session_user.user_feed_setting.sponsoring;
          this.is_unlock = this.session_user.user_feed_setting.unlock;
          this.$nextTick(() => {
              this.has_init = true;
          })
      }
    },
    tab(n) {
        this.status = n
        if(n == 2){
            this.get_blacklist()
        }
    },
    async submit(post_data){
        if(this.$http.is_run(POST_UPDATE_USER_FEED_SETTING)){
            return false
        }
        let data = await this.$http.$axios(POST_UPDATE_USER_FEED_SETTING, post_data)
        if(data.ec != 200){
            this.$notify({
                title: data.em,
                group: 'error',
            })
            return false
        }
        this.$bus.$emit("FEED_REFRESH");
    },
    async get_blacklist(){
        if(this.$http.is_run(GET_BLOCKED_CREATORS)){
            return false
        }
        let data = await this.$http.$axios(GET_BLOCKED_CREATORS)
        if(data.ec != 200){
            this.$notify({
                title: data.em,
                group: 'error',
            })
            return false
        }
        this.has_load = true;
        this.user_list = data.data.user_list
    },
    cancel_blacklist(user_id){
          this.submit({in_blacklist: 0,user_id})
          this.app_action_sheet('close')
    },
    filter(){
        // this.$
        // this.$bus.$emit("FEED_REFRESH");
        // this.app_action_sheet('close')
    },

  }
};
</script>

<style lang="stylus" scoped>
.vm-action-feed-filter {
    background: $white;
    padding:24px 0px;
    box-sizing: border-box;
    min-width:350px;
    // transform:translate(0,100%);
    // transition:all .2s ease-out;
    // &.on{
    //     transform:translate(0,0);
    // }
    .line{
      background:#F7F7F7;
      margin-left:16px;
      margin-right:16px;
      width:calc(100% - 32px);
      box-sizing:border-box;
    }
    .item{
      padding:0 16px;
      margin-bottom:24px;
      &:last-child{
        margin-bottom:0px;
      }
    }
    &.small {
        min-width:auto;
        background: $white;
        border-radius:8px 8px 0 0;
        padding:24px 0 40px 0;
        position:fixed;
        left:0;
        width:100%;
        bottom:0;
    }
    &.safe-space{
      padding-bottom:$safe-space;
    }
}
</style>
